import { formatRp, formatDateID, formatDateLong, PAYMENT_STATUS_STYLES } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ServiceBadge } from "@/components/Badges";

function Row({ label, value, strong }) {
  return (
    <div className="flex justify-between gap-4 border-b border-rose-50 py-2 text-sm last:border-0">
      <span className="text-slate-500">{label}</span>
      <span className={`text-right ${strong ? "font-heading text-base font-extrabold text-[#6A38C7]" : "font-semibold text-slate-800"}`}>{value ?? "-"}</span>
    </div>
  );
}

export default function TransactionDetail({ tx, open, onClose }) {
  const d = tx;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto rounded-2xl sm:max-w-md" data-testid="transaction-detail">
        {d && (
          <>
            <DialogHeader><DialogTitle className="font-heading text-xl">{d.nama_lengkap}</DialogTitle></DialogHeader>
            <div className="mb-2 flex flex-wrap gap-1.5">
              <ServiceBadge service={d.jenis_layanan} />
              <span className={`rounded-full border px-2.5 py-0.5 text-xs font-bold ${PAYMENT_STATUS_STYLES[d.status_pembayaran] || "bg-slate-100 text-slate-600 border-slate-200"}`}>{d.status_pembayaran || "-"}</span>
            </div>
            <Row label="Tanggal Layanan" value={formatDateLong(d.tanggal_layanan || d.tanggal_kunjungan)} />
            <Row label="Petugas" value={d.petugas_nama || "-"} />
            <Row label="Lokasi" value={d.lokasi || "-"} />
            <Row label="Kategori" value={d.kategori_layanan || "-"} />
            <Row label="Harga Normal" value={formatRp(d.harga_normal)} />
            <Row label="Diskon" value={d.jenis_diskon === "Persentase" ? `${d.nilai_diskon}%` : formatRp(d.nilai_diskon)} />
            <Row label="Potongan Lainnya" value={formatRp(d.potongan_lainnya)} />
            {Number(d.biaya_homecare) > 0 && <Row label="Biaya Homecare" value={formatRp(d.biaya_homecare)} />}
            {Number(d.biaya_bahan) > 0 && <Row label="Biaya Bahan" value={formatRp(d.biaya_bahan)} />}
            <Row label="Harga Final" value={formatRp(d.harga_final)} strong />
            <Row label="Metode Pembayaran" value={d.metode_pembayaran || "-"} />
            <Row label="Alasan Diskon/Potongan" value={d.alasan_diskon || "-"} />
            <Row label="Catatan Admin" value={d.catatan_admin || "-"} />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
